import type { RelatedCluster } from "@/domain/cluster/constants"
import type { RelatedCollaborator } from "@/domain/collaborator/constants"

export type EntityLocked = {
  id: string
  collaborator?: (RelatedCollaborator & {
    id: string
    firstname?: string
    lastname?: string
    fullname?: string
  })[]
  cluster?: (RelatedCluster & { id: string; name?: string })[]
} & ({ name?: string } | { firstname?: string; lastname?: string })

export const SHARED_DATA_STATUS = {
  ASKED: "asked",
  ACCEPTED: "accepted",
  DENIED: "denied",
  REVOKED: "revoked",
  CANCELLED: "cancelled",
  COMPLETED: "completed",
  CLOSED: "closed",
  ARCHIVE: "archive",
} as const
export type SHARED_DATA_STATUS = typeof SHARED_DATA_STATUS
export type SHARED_DATA_STATUS_VALUE = SHARED_DATA_STATUS[keyof SHARED_DATA_STATUS]

export const SHARED_DATA_TYPE = {
  PEOPLE: "people",
  PROJECT: "project",
  INTER_BU: "interbu",
}
export type SHARED_DATA_TYPE = typeof SHARED_DATA_TYPE
export type SHARED_DATA_TYPE_VALUE = SHARED_DATA_TYPE[keyof SHARED_DATA_TYPE]
